import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import { Link } from '@ui/Link';
import { Button } from '@ui/Button';
import { Title } from '@ui/Title';

import s from './MainCities.sss';

const getCities = () => ([
  {
    prefix: t`у`,
    name: t`Дніпрі`,
    slug: 'dnepropetrovsk',
  },
  {
    prefix: t`в`,
    name: t`Одесі`,
    slug: 'odessa',
  },
  {
    prefix: t`у`,
    name: t`Харкові`,
    slug: 'harkov',
  },
  {
    prefix: t`у`,
    name: t`Львові`,
    slug: 'lvov',
  },
  {
    prefix: t`в`,
    name: t`Запоріжжі`,
    slug: 'zaporozhe',
  },
  {
    prefix: t`у`,
    name: t`Києві`,
    slug: '',
  },
  {
    prefix: t`у`,
    name: t`Кривому Розі`,
    slug: 'krivoy-rog',
  },
  {
    prefix: t`у`,
    name: t`Миколаєві`,
    slug: 'nikolaev',
  },
  {
    prefix: t`у`,
    name: t`Вінниці`,
    slug: 'vinnica',
  },
  {
    prefix: t`у`,
    name: t`Житомирі`,
    slug: 'zhitomir',
  },
  {
    prefix: t`у`,
    name: t`Чернігові`,
    slug: 'chernigov',
  },
  {
    prefix: t`у`,
    name: t`Сумах`,
    slug: 'sumy',
  },
  {
    prefix: t`у`,
    name: t`Полтаві`,
    slug: 'poltava',
  },
  {
    prefix: t`у`,
    name: t`Рівному`,
    slug: 'rovno',
  },
  {
    prefix: t`у`,
    name: t`Черкасах`,
    slug: 'cherkassy',
  },
  {
    prefix: t`у`,
    name: t`Хмельницькому`,
    slug: 'hmelnickiy',
  },
  {
    prefix: t`у`,
    name: t`Кропивницькому`,
    slug: 'kirovograd',
  },
]);

export const MainCities = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className={s.column}>
        <Title
          className={s.title}
          type='h3'
          bold={false}
        >
          {t`Жінкам`}
        </Title>

        <ul className={s.list}>
          {getCities().map((city, i) => (
            <li
              key={i}
              className={classNames(s.item, {
                [s.itemStateHidden]: i > 4 && !isOpen,
              })}
            >
              {city.prefix}
              &nbsp;
              <Link
                className={s.link}
                theme='black'
                href={history.createHref({ pathname: city.slug ? `/women/gorod-${city.slug}` : '/women' })}
              >
                {city.name}
              </Link>
            </li>
          ))}
        </ul>

        <Button
          className={s.button}
          theme='text'
          onClick={() => setIsOpen((prevState) => !prevState)}
        >
          {isOpen ? t`Показати менше` : t`Показати більше`}
        </Button>
      </div>

      <div className={s.column}>
        <Title
          className={s.title}
          type='h3'
          bold={false}
        >
          {t`Чоловікам`}
        </Title>

        <ul className={s.list}>
          {getCities().map((city, i) => (
            <li
              key={i}
              className={classNames(s.item, {
                [s.itemStateHidden]: i > 4 && !isOpen,
              })}
            >
              {city.prefix}
              &nbsp;
              <Link
                className={s.link}
                theme='black'
                href={history.createHref({ pathname: city.slug ? `/men/gorod-${city.slug}` : '/men' })}
              >
                {city.name}
              </Link>
            </li>
          ))}
        </ul>

        <Button
          className={s.button}
          theme='text'
          onClick={() => setIsOpen((prevState) => !prevState)}
        >
          {isOpen ? t`Показати менше` : t`Показати більше`}
        </Button>
      </div>
    </>
  );
};
